import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'Martín Sosa',
  location: 'Córdoba',
  text: 'Excelente material. Me ayudó a estructurar las sesiones con pacientes que presentan rumiación nocturna severa. La distinción entre perfiles es súper clara y aplicable desde el primer día.',
  initials: 'MS'
}, {
  name: 'Carolina Fernández',
  location: 'Buenos Aires',
  text: 'La distinción entre insomnio por ansiedad y por depresión es clave. Los protocolos son claros y fáciles de aplicar en el consultorio. Dejé de dar recomendaciones genéricas.',
  initials: 'CF'
}, {
  name: 'Javier Romero',
  location: 'Rosario',
  text: 'Buscaba algo práctico y directo. Las matrices de conceptualización me ahorraron mucho tiempo de planificación. Muy recomendable para quienes trabajamos en clínica de adultos.',
  initials: 'JR'
}, {
  name: 'Sofía Albornoz',
  location: 'Mendoza',
  text: 'Los recursos descargables para los pacientes son un plus enorme. El diario de sueño es súper amigable y no genera resistencia. Me ordenó muchísimo el abordaje.',
  initials: 'SA'
}, {
  name: 'Mariana Quiroga',
  location: 'La Plata',
  text: 'Me dio mucha seguridad para abordar casos mixtos. Las preguntas clínicas y las reformulaciones cognitivas son precisas y van directo al problema de base.',
  initials: 'MQ'
}];
export const Testimonials: React.FC = () => {
  return <section className="py-12 sm:py-16 bg-white px-4 sm:px-6 lg:px-8" data-id="element-183">
      <div className="max-w-6xl mx-auto" data-id="element-184">
        <h2 className="font-serif text-2xl sm:text-3xl font-bold text-navy mb-8 sm:mb-12 text-center" data-id="element-185">
          Lo que dicen otros profesionales
        </h2>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6" data-id="element-186">
          {TESTIMONIALS.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-offwhite p-4 sm:p-6 rounded-xl border border-lavender-muted shadow-sm" data-id="element-187">
              <div className="flex items-center gap-1 mb-2 sm:mb-4" data-id="element-188">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-3 h-3 sm:w-4 sm:h-4 fill-yellow-400 text-yellow-400" data-id="element-189" />)}
              </div>
              <p className="text-gray-700 italic mb-3 sm:mb-6 text-xs sm:text-sm leading-relaxed" data-id="element-190">
                "{t.text}"
              </p>
              <div className="flex items-center gap-2 sm:gap-3 mt-auto" data-id="element-191">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-navy text-white rounded-full flex items-center justify-center font-bold text-xs sm:text-sm shrink-0" data-id="element-192">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-193">
                  <p className="font-bold text-navy text-xs sm:text-sm truncate" data-id="element-194">
                    {t.name}
                  </p>
                  <p className="text-[10px] sm:text-xs text-gray-500 truncate" data-id="element-195">
                    {t.location}, Argentina
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};